import { filter } from "rxjs";
import { io } from "socket.io-client"
import { configService } from "./config.service";
import { Utils } from "../js/utils.js";

class SocketIOService {
    constructor() {
        this.graphNode = null;
		this.graphNodeOnce = null;
        this.mode = Utils.getURLParameter("mode");
		this.mirrorComponent = null;
	}
	
	init(mirrorComponent){
		this.mirrorComponent = mirrorComponent;
		
        configService.config$
            .pipe(filter(config => config !== null))
            .subscribe((config) => {
                let options = {
                    transportOptions: {
                        polling: {
                            extraHeaders: {
                                'Authorization': `Bearer ${config.token}`,
                            },
                        },
                    },
                    query: {
                        mirror: config.name
                    }
                }
            if(this.mode==="kiosk" || this.mode==="wall")
                this.socket = io(`${config.mirrorURL}/mirror`, options);

            if(this.mode==="wall")
            {
                this.socket.on('graphNode', (graphNode) => {
                    this.mirrorComponent.applyGraphNode(graphNode.graphNode);
                });
            }
        });
    }

    send(graphNode) {
        this.socket.emit("graphNode", graphNode);
    }

}

export const socketIOService = new SocketIOService();